exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-form-edit-component-alert-max-variant {\n    right: 100px !important;\n    bottom: 100px !important;\n    max-width: 600px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/product/form/edit.component.css
// module id = 6122
// module chunks = 0